import { useRef, useEffect } from 'react'
import ListStandardRals from './ListStandardRals'
import ListSpecialRals from './ListSpecialRals'
import CurrentUniqueRals from './CurrentUniqueRals'
import LatestRal from './LatestRal'
import { listColors, listColorCategories } from '../utils/bike-schema'
import { fontColorForBackground, isLetter } from '../utils/colors'
import { formatCurrencyAlwaysSign } from '../utils/money'
import { t } from '../utils/i18n'

const RalPicker = ({
  activeRal,
  priceDiffForRal,
  currencyCode,
  onSelect,
  choices,
  latestPickedRals
}) => {
  let categoriesEl = useRef(null)
  let colorsEl = useRef(null)

  const scrollColorIntoView = (ral) => {
    const colorEl = colorsEl.querySelector(
      `.velorbis-customizer-ral-picker-color[data-ral="${ral}"]`
    )
    const colorRect = colorEl.getBoundingClientRect()
    const colorsRect = colorsEl.getBoundingClientRect()

    colorsEl.scrollTop = colorRect.top - colorsRect.top + colorsEl.scrollTop
  }

  const syncActiveCategory = () => {
    const activeCategory = categoriesEl.querySelector(
      '.velorbis-customizer-ral-picker-category-active'
    )
    const colorsTop = colorsEl.getBoundingClientRect().top
    const colorEls = document.body.querySelectorAll(
      '.velorbis-customizer-ral-picker-color'
    )
    for (let i = 0; i < colorEls.length; i++) {
      const colorEl = colorEls[i]
      const colorBottom = colorEl.getBoundingClientRect().bottom
      if (colorBottom > colorsTop) {
        let currentColorEl = colorEl.dataset.ral
        let letter = ''
        if (isLetter(currentColorEl)) {
          letter = currentColorEl[0]
          currentColorEl = currentColorEl.substring(1)
        }

        const categories = document.body.querySelectorAll(
          '.velorbis-customizer-ral-picker-category'
        )
        for (let j = categories.length - 1; j >= 0; j--) {
          const category = categories[j]
          if (!letter) {
            const colorRal = parseInt(currentColorEl, 10)
            const categoryRal = parseInt(category.dataset.ral, 10)
            if (categoryRal <= colorRal) {
              if (activeCategory) {
                activeCategory.classList.remove(
                  'velorbis-customizer-ral-picker-category-active'
                )
              }
              category.classList.add(
                'velorbis-customizer-ral-picker-category-active'
              )
              break
            }
          } else if (letter == category.dataset.ral[0]) {
            if (activeCategory) {
              activeCategory.classList.remove(
                'velorbis-customizer-ral-picker-category-active'
              )
            }
            category.classList.add(
              'velorbis-customizer-ral-picker-category-active'
            )
            break
          }
        }
        break
      }
    }
  }

  useEffect(() => {
    syncActiveCategory()
    scrollColorIntoView('Q') // initial RalPicker position at quick-pick
  }, [])

  return (
    <div className="velorbis-customizer-ral-picker">
      <div
        className="velorbis-customizer-ral-picker-categories"
        ref={(el) => (categoriesEl = el)}
      >
        {listColorCategories().map(({ name, title }, i) => {
          return (
            <div
              key={i}
              data-ral={title}
              className="velorbis-customizer-ral-picker-category"
              onClick={() => scrollColorIntoView(title)}
            >
              {name}
            </div>
          )
        })}
      </div>
      <div
        className="velorbis-customizer-ral-picker-colors"
        ref={(el) => (colorsEl = el)}
        onScroll={syncActiveCategory}
      >
        <ListStandardRals
          activeRal={activeRal}
          priceDiffForRal={priceDiffForRal}
          onSelect={onSelect}
          currencyCode={currencyCode}
        />
        <ListSpecialRals
          activeRal={activeRal}
          choices={choices}
          priceDiffForRal={priceDiffForRal}
          onSelect={onSelect}
          currencyCode={currencyCode}
        />
        <CurrentUniqueRals
          choices={choices}
          priceDiffForRal={priceDiffForRal}
          activeRal={activeRal}
          onSelect={onSelect}
          currencyCode={currencyCode}
        />
        {latestPickedRals.length > 0 && (
          <LatestRal latestPickedRals={latestPickedRals} onSelect={onSelect} />
        )}
        <div
          data-ral={1000}
          className="velorbis-customizer-ral-picker-color head"
        >
          {t('all_colors')}:
        </div>
        {listColors().map(({ ral, hex, name }) => {
          const priceDiff = priceDiffForRal ? priceDiffForRal(ral) : 0
          if (ral >= 1000)
            return (
              <div
                key={ral}
                className="velorbis-customizer-ral-picker-color"
                style={{
                  backgroundColor: hex,
                  color: fontColorForBackground(hex)
                }}
                data-ral={ral}
                onClick={() => onSelect(ral)}
              >
                <div className="velorbis-customizer-ral-picker-color-name">
                  RAL {ral}: {name}
                  {priceDiff !== 0 && (
                    <span className="velorbis-customizer-ral-picker-color-price">
                      {' '}
                      {formatCurrencyAlwaysSign(priceDiff, currencyCode)}
                    </span>
                  )}
                  {activeRal == ral && (
                    <div className="velorbis-customizer-ral-picker-color-selected">
                      {t('selected')}
                    </div>
                  )}
                </div>
              </div>
            )
        })}
      </div>
    </div>
  )
}

export default RalPicker
